import { Skeleton } from 'primereact/skeleton'

/**
 * Paylaşılan yükleme iskeleti (paylaşılan ui katmanı — Reuse Mandate; anayasa Page Standards:
 * yükleme için skeleton/spinner, aynı sayfada karıştırılmaz). PrimeReact `Skeleton` üzerine kurulu;
 * belirtilen sayıda satır çizer (varsayılan 3), son satır kısaltılır (doğal metin hissi).
 */
export interface LoadingSkeletonProps {
  /** Çizilecek satır sayısı (varsayılan 3). */
  lines?: number
  /** Her satırın yüksekliği (varsayılan "1rem"). */
  height?: string
  className?: string
}

export default function LoadingSkeleton({
  lines = 3,
  height = '1rem',
  className,
}: Readonly<LoadingSkeletonProps>) {
  return (
    <div className={`ui-skeleton${className ? ` ${className}` : ''}`} aria-busy role="status">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton
          key={i}
          height={height}
          width={i === lines - 1 ? '60%' : '100%'}
          className="ui-skeleton-line"
        />
      ))}
    </div>
  )
}
